<template>

  <div class="">
    <header class="shadow-xl">
      <!-- =============================== header 1 ===============================  -->
      <topo :user="userisloged"></topo>

      <!-- =============================== header 2 ===============================  -->
      <section class="bg-white hidden lg:block xl:block ">
        <div class="container mx-auto px-20 py-2 ">
          <div class="flex">
            <div class="w-1/2 p-2 text-center my-auto">
              <h6 class="font-bold Arial text-left">ENTREGA: <span class="text-gray-500">{{$route.params.token}}</span></h6>
            </div>
            <div class="w-2/2 p-2 text-center">
              <ul class="order-list">
                <li class="arrow_box-right active">Informações pessoais</li>
                <li class="arrow_box-right" v-bind:class="{'active' : (etapa >= 2)}">Entrega</li>
                <li class="arrow_box-right" v-bind:class="{'active' : (etapa == 3)}">Ordem</li>
              </ul>
            </div>
          </div>
        </div>
      </section>


    </header>
    <main>
      <section class="container mx-auto py-8 px-8 md:px-20" v-if="etapa == 1 || etapa == 2">
        <div>
          <h1 class="text-center md:text-left text-gray-900 font-bold poppins text-2xl" v-if="userisloged">Olá, {{userisloged.nome}}</h1>
          <h2 class="text-center md:text-left poppins text-base">Você precisa preencher suas informações de endereço para poder receber o seu produto.</h2>
        </div>

        <!-- =============================== Cupom area ===============================  -->
        <div class="md:flex mt-10">
          <div class="w-full lg:w-1/2 md:p-6">
            <div class="">
              <h3 class="gray-wdc text-sm pl-4">TOKEN DE ACESSO</h3>
              <input class="cupom-input we-gray we-font-gray p-4 rounded-md text-lg font-bold w-full mt-6" type="text" :value="$route.params.token" disabled>
            </div>
            <div class="">
              <h3 class="text-center text-xl md:text-left Arial font-bold md:text-2xl text-gray-900 mt-12" v-if="etapa === 1">Suas informações pessoais</h3>
              <h3 class="text-center text-xl md:text-left Arial font-bold md:text-2xl text-gray-900 mt-12" v-if="etapa === 2">Suas informações de entrega</h3>
              <div class="bg-white w-full rounded-md my-4">
                <form class="w-full px-10 pt-10 pb-3" v-if="etapa == 1">
                  <div class="flex flex-col">
                    <h3 class="gray-wdc font-bold">DESTINATÁRIO</h3>
                    <input class="poppins text-gray-700 font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4"
                           v-model="dados.nome" type="text" required>
                  </div>
                  <div class="vx-row mt-2">
                    <div class="vx-col w-3/12">
                      <h3 class="gray-wdc font-bold">DDD</h3>
                      <input class="poppins text-gray-700 font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4"
                             v-model="dados.ddd" type="text" required v-mask="'##'" @keypress="isNumber">
                    </div>
                    <div class="vx-col w-9/12">
                      <h3 class="gray-wdc font-bold">TELEFONE</h3>
                      <input class="poppins text-gray-700 font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4"
                             v-model="dados.telefone" type="text" required v-mask="['####-####', '#####-####']" @keypress="isNumber">
                    </div>
                  </div>
                  <vs-button class="dados-btn hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full h-16 Arial text-xl md:text-2xl my-5" @click="validaPessoais" :disabled="invalidoPessoais">
                    Confirmar dados
                  </vs-button>
                </form>
                <transition name="fade" v-if="etapa == 2">
                  <form class="w-full px-10 pt-10 pb-3 vs-con-loading__container" @submit="buscaCep" id="div-with-loading">
                    <div class="flex flex-col">
                      <h3 class="gray-wdc font-bold">CEP (CÓDIGO POSTAL)</h3>
                      <input class="poppins text-gray-700 font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4"
                             v-model="dados.cep" type="text" required @keypress="isNumber" v-mask="'########'">
                    </div>
                    <button class="dados-btn hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full h-16 Arial text-xl md:text-2xl mb-5" v-if="!valido" type="submit">
                      Buscar
                    </button>
                    <div v-if="valido">
                      <div class="flex flex-col mt-8">
                        <h3 class="gray-wdc font-bold">ESTADO {{errors.any()}}</h3>
                        <input class="poppins text-gray-700  font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4 bg-gray-300" name="estado" v-validate="'required|max:2'" type="text" required
                               v-model="dados.estado"
                               :disabled="true"/>
                        <span class="text-danger text-sm" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                      </div>
                      <div class="flex flex-col">
                        <h3 class="gray-wdc font-bold">CIDADE</h3>
                        <input class="poppins text-gray-700 font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4 bg-gray-300 " name="cidade" v-validate="'required|max:30'" type="text" required
                               v-model="dados.cidade"
                               :disabled="true"/>
                        <span class="text-danger text-sm" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</span>
                      </div>
                      <div class="flex flex-col">
                        <h3 class="gray-wdc font-bold">BAIRRO</h3>
                        <input class="poppins text-gray-700  font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4" name="bairro" v-validate="'required|max:30'" :class="{ 'bg-gray-300' : habBairro}"
                               type="text" required v-model="dados.bairro"
                               :disabled="habBairro"/>
                        <span class="text-danger text-sm" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</span>
                      </div>
                      <div class="flex flex-col">
                        <h3 class="gray-wdc font-bold">ENDERECO</h3>
                        <input class="poppins text-gray-700  font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4" name="endereco" v-validate="'required|max:50'" :class="{ 'bg-gray-300' : habEndereco}"
                               type="text" required v-model="dados.endereco"
                               :disabled="habEndereco"/>
                        <span class="text-danger text-sm" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</span>

                      </div>
                      <div class="flex flex-col">
                        <h3 class="gray-wdc font-bold">COMPLEMENTO</h3>
                        <input class="poppins text-gray-700  font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4" name="complemento" v-validate="'max:30'" type="text" required v-model="dados.complemento"/>
                        <span class="text-danger text-sm" v-show="errors.has('complemento')">{{ errors.first('complemento') }}</span>
                      </div>
                      <div class="flex flex-col">
                        <h3 class="gray-wdc font-bold">NÚMERO</h3>
                        <input class="poppins text-gray-700  font-bold h-12 border-2 border-gray-500 w-full rounded-md my-2 p-4" name="numero" v-validate="'required|max:5'" type="text" required v-model="dados.numero"
                               @keypress="isNumber"/>
                        <span class="text-danger text-sm" v-show="errors.has('numero')">{{ errors.first('numero') }}</span>

                      </div>
                      <vs-button class="dados-btn hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full h-16 Arial text-xl md:text-2xl my-3" type="submit" @click="storeEntrega"
                                 :disabled="invalidoEntrega">
                        Confirmar dados
                      </vs-button>
                    </div>
                  </form>
                </transition>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/2 mt-6 md:mt-0 md:p-6 ">
            <h3 class="text-2xl Arial font-bold">O que será entregue</h3>
            <div class="bg-white border-2 md:mt-3 border-gray-400">
              <div class=" flex mt-4">
                <div class="w-4/12 p-6 md:p-10">
                  <img src="@/assets/images/weentregas/box-logo-black.png" width="100%" alt="">
                </div>
                <div class="w-8/12 my-auto">
                  <h4 class="text-base md:text-lg font-bold text-gray-900 ">{{this.brinde.nome}}</h4>
                  <p class="text-sm text-gray-600 Arial">O prazo de entrega dependerá do seu endereço de entrega.</p>
                </div>
              </div>
              <hr class="new2">

              <div class="p-2 flex my-3 md:mb-5">
                <div class="md:w-3/12 md:mt-2 md:px-8 xl:px-10 md:mx-6 mx-4 mt-2 md:ml-3">
                  <img src="@/assets/images/weentregas/brazil.png" width="100%" alt="">
                </div>

                <div class="w-9/12 my-auto">
                  <h4 class="text-base md:text-lg font-bold text-gray-900 ">Enviamos para todo Brasil</h4>
                  <p class="text-sm text-gray-600">São aceitos apenas endereços no território brasileiro, caso você resida em outro país é necessário que alguém de sua confiança receba o pacote e
                    encaminhe à seu endereço Internacional, (custos por sua conta, neste caso).</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <transition name="fade" v-else>
        <ordem :brinde="brinde"></ordem>
      </transition>
    </main>
  </div>

</template>

<script>
  import moduleWeentrega from "../../store/weentrega/moduleWeentrega";
  import topo from "./components/Topo.vue"

  import Ordem from "./Ordem";
  import {Validator} from 'vee-validate';

  const dict = {
    custom: {
      estado: {
        required: 'Por favor, insira o Estado ',
        max: 'O limite maximo é de 2 caracters',
      },
      cidade: {
        required: 'Por favor, insira o Cidade ',
        max: 'O limite maximo é de 30 caracters',
      },
      bairro: {
        required: 'Por favor, insira o Bairro ',
        max: 'O limite maximo é de 30 caracters',
      },
      endereco: {
        required: 'Por favor, insira o Endereco ',
        max: 'O limite maximo é de 50 caracters',
      },
      complemento: {
        required: 'Por favor, insira o Complemento ',
        max: 'O limite maximo é de 30 caracters',
      },
      numero: {
        required: 'Por favor, insira o Numero ',
        max: 'O limite maximo é de 5 caracters',
      },
    }
  };
  Validator.localize('pt-br', dict);

  export default {
    components: {Ordem, topo},
    data() {
      return {
        etapa: 1,
        dados: {
          cep: null,
          cidade: '',
          estado: '',
          bairro: '',
          complemento: '',
          endereco: '',
          numero: '',
          ddd: '',
          telefone: '',
          nome: '',
        },
        habBairro: true,
        habEndereco: true,
        valido: false,
        brinde: {},
        antigoCep: '',
        user: {},
      }
    },
    created() {
      if (!moduleWeentrega.isRegistered) {
        this.$store.registerModule("weentrega", moduleWeentrega);
        moduleWeentrega.isRegistered = true;
      }

      localStorage.removeItem('weeLogged')
      this.consultarAutomacao();
    },
    computed: {
      userisloged() {
        let user = JSON.parse(localStorage.getItem('weeLogged')) || this.user
        return user;
      },
      invalidoPessoais() {
        return (!this.dados.ddd || !this.dados.telefone || !this.dados.nome || this.dados.telefone.length <= 8)
      },
      invalidoEntrega() {
        return this.errors.any()
      },
    },

    methods: {
      consultarAutomacao() {
        if (this.$route.params.email != null && this.$route.params.token != null) {

          this.$store.dispatch('weentrega/login', {email: this.$route.params.email, token: this.$route.params.token}).then((response) => {
            this.user = response.data;
            this.consulta()
          }).catch(() => {
            this.$router.push({name: 'login'})
          });

        } else this.$router.push({name: 'login'});
      },
      consulta() {
        this.$store.dispatch('weentrega/consulta', {token: this.$route.params.token}).then(response => {
          this.expedicao = response.expedicao;
          if (this.expedicao != null) {
            if (this.expedicao.fechado || !(this.expedicao.rastreio_melhor_envio == null || this.expedicao.rastreio_melhor_envio == '' || this.expedicao.rastreio_melhor_envio == 'pending') ) {
              this.$vs.notify({
                title: 'Alerta',
                text: 'A expedição desta solicitação já consta como fechada',
                color: 'danger',
                delay: 5000
              });
              this.$router.push({name: 'inicio'});
            }
          }
          this.brinde = response.brinde;
          if (response.endereco) {
            this.dados = response.endereco;
            this.dados.ddd = this.dados.telefone.substring(0, 2);
            this.dados.telefone = this.dados.telefone.replace(this.dados.ddd, '');
            this.valido = true;
            this.antigoCep = this.dados.cep;
          }
        }).catch(() => {
          this.$router.push({name: 'inicio'});
        })
      },
      validaPessoais() {
        this.dados.nome = this.removeAccents(this.dados.nome);
        this.etapa = 2;
      },
      buscaCep(e) {
        e.preventDefault();
        if (!this.valido) {
          this.dados.complemento = '';
          this.dados.numero = '';
          this.$store.dispatch('weentrega/brasilapi', this.dados.cep).then(response => {
            this.valido = true;
            this.antigoCep = this.dados.cep;
            this.dados.cidade = this.removeAccents(response.city);
            this.dados.estado = this.removeAccents(response.state);

            this.dados.bairro = this.removeAccents(response.neighborhood);
            this.dados.endereco = this.removeAccents(response.street);
            if (response.neighborhood == '' || !response.neighborhood) {
              this.habBairro = false
            }
            if (response.street == '' || !response.street) {
              this.habEndereco = false
            }
            if (response.address == '' || !response.address) {
              this.habEndereco = false
            }
          }).catch(erro => {
            this.$vs.notify({
              title: '',
              color: 'danger',
              text: erro.message
            })
          }).finally(()=>{
            this.$validator.validateAll()
          });
        }
      },
      removeAccents(str) {
        if (str){
    let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('').toUpperCase();
        }
        return str;
      },
      storeEntrega() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.loading({
              container: '#div-with-loading',
              scale: 0.6
            })
            this.dados.email = this.userisloged.email;
            this.dados.token = this.$route.params.token;
            this.dados.telefone = this.dados.ddd + this.dados.telefone.replace('-', '');
            this.$store.dispatch('weentrega/storeEntrega', this.dados).then(() => {
              this.$vs.loading.close();
              this.etapa = 3;
            }).catch(() => {
              this.$vs.notify({
                title: '',
                type: 'alert',
                color: 'danger',
                text: 'Algo deu errado ao salvar seu endereço'
              });
              this.$vs.loading.close()
            });
          }
          else {
            this.$vs.notify({
              title: '',
              text: 'verifique os erros específicos',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        });
      }
    },
    watch: {
      name(newName) {
        localStorage.name = newName;
      },
      dados: {
        handler: function (e) {
          if (e.cep != this.antigoCep) {
            this.valido = false;
          }
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .boas-vindas {
    background-image: url('../../assets/images/novaintegracao/bg-boas-vindas.png') !important;
    background-size: cover;
    background-position: center;
  }

  .dourado {
    color: #F0A977 !important;
  }

  .btn-next {
    letter-spacing: 3px;
    background-color: #F0A977;
    width: 250px;
    height: 70px;
  }
</style>